import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  setSearchStatus,
  setSearchError,
  clearSearchAnswer,
  putSource,
  setPreviewError,
} from './searchSlice';
import ragQuestionAnswer from '../../services/ragService';
import { getFile } from '../../services/fileSystemService';

export const searchRecordings = createAsyncThunk(
  'search/searchRecordings',
  async (query: string, { dispatch }) => {
    try {
      dispatch(setSearchStatus('loading'));
      dispatch(clearSearchAnswer());

      // TODO consider whether we want to identify each query with a GUID
      // Match the GUID later on socket.io update
      await ragQuestionAnswer(query);

      dispatch(setSearchStatus('idle'));
    } catch (error) {
      dispatch(
        setSearchError(error instanceof Error ? error.message : 'Search failed')
      );
      dispatch(setSearchStatus('failed'));
      throw error;
    }
  }
);

export const getSelectedSource = createAsyncThunk(
  'search/selectedSource',
  async (fileId: string, { dispatch }) => {
    try {
      const file = await getFile(fileId);
      dispatch(putSource(file.file));
      return file;
    } catch (error) {
      setPreviewError(
        'Sorry, We are unable to load the source preview. Please try later'
      );
      throw error;
    }
  }
);

const searchAPI = {
  searchRecordings,
  getSelectedSource,
};

export default searchAPI;
